import { DaoModel } from '@dynameat/models';
import { dateToUnixSeconds, timeToUnixSeconds } from '@core/helpers/dates';

export class Interval extends DaoModel {
  constructor(monday, tuesday, wednesday, thursday, friday, saturday, sunday, timeFrom, timeTo) {
    super(null);
    this.monday = monday || false;
    this.tuesday = tuesday || false;
    this.wednesday = wednesday || false;
    this.thursday = thursday || false;
    this.friday = friday || false;
    this.saturday = saturday || false;
    this.sunday = sunday || false;
    this.timeFrom = timeToUnixSeconds(timeFrom);
    this.timeTo = timeToUnixSeconds(timeTo);
  }

  static toInstance(props = {}) {
    return new Interval(props.monday, props.tuesday, props.wednesday, props.thursday,
      props.friday, props.saturday, props.sunday, props.time_from, props.time_to);
  }

  isBetweenTime(datetime) {
    const time = dateToUnixSeconds(datetime);
    // We don't need a midnight fallback because intervals don't work across days by default
    return time >= this.timeFrom && time <= this.timeTo;
  }
}
